import React from 'react';
export var CheckCircle = function CheckCircle() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "19.5",
    cy: "19.5",
    r: "18.625",
    stroke: "inherit",
    strokeWidth: "1.75",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4288 14.648L17.0873 24.9894L11.5719 19.474",
    stroke: "inherit",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }));
};